import "./App.css";
import Header from "./components/Header";
import BookingForm from "./components/BookingForm";
import PreviewData from "./components/PreviewData";
import { Provider } from "react-redux";
import store from "./features/store";

function App() {
 return (
  <Provider store={store}>
   <Header />
   <section>
    {/* <!-- Input Data --> */}
    <BookingForm />

    {/* <!-- Preview Data --> */}
    <PreviewData />
   </section>
  </Provider>
 );
}

export default App;
